import { render, staticRenderFns } from "./yanshoudan.vue?vue&type=template&id=249a2a42&scoped=true&"
import script from "./yanshoudan.vue?vue&type=script&lang=js&"
export * from "./yanshoudan.vue?vue&type=script&lang=js&"
import style0 from "./yanshoudan.vue?vue&type=style&index=0&id=249a2a42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a2a42",
  null
  
)

export default component.exports